import classNames from 'classnames';

import { AccordionItem as IAccordionItem } from '../../../../types/working-model';
import styles from '../../../../scss/live-event/base/modules/accordion modules/accordion-container.module.scss';
import AccordionItem from './accordion-item';
import { UniqueIdentifier } from '@dnd-kit/core';

interface IAccordionColumnProps {
	column: { columnId: UniqueIdentifier; columnItems: IAccordionItem[] };
	vertical: boolean;
	activeItemState: [Record<UniqueIdentifier, UniqueIdentifier>, React.Dispatch<React.SetStateAction<Record<UniqueIdentifier, UniqueIdentifier>>>]
	itemTabIndex: number;
	moduleId: number;
}

const AccordionColumn = (props: IAccordionColumnProps) => {
	const { column, vertical, activeItemState, itemTabIndex, moduleId } = props;

	const [activeSection, setActiveSection] = activeItemState;

	const columnId = column.columnId;

	const handleOpenItem = (itemId: UniqueIdentifier) => {
		setActiveSection(prev => {
			return {
				...prev,
				...(prev[columnId] === itemId ? { [columnId]: '' } : { [columnId]: itemId })
			};
		});
	};

	return (
		<div
			className={classNames(
				"accordion-column",
				styles.Container,
				vertical && styles.vertical
			)}
		>
			<ul>
				{column.columnItems.map(item => {
					const open = activeSection[columnId] === item.id;
					return (
						<AccordionItem
							key={item.id}
							moduleId={moduleId}
							item={item}
							handleOpenItem={handleOpenItem}
							open={open}
							tabIndex={itemTabIndex}
						/>
					);
				})}
			</ul>
		</div>
	);
};

export default AccordionColumn;
